import { ApplicationState } from 'redux/Stores/types'

export const selectAnalysisGenerating = (state: ApplicationState) =>
  state.AnalysisGenerationStore.generating

export const selectLatestAnalysisGenerations = (state: ApplicationState) =>
  state.AnalysisGenerationStore.latest

export const selectAnalysisGenerationsFetched = (state: ApplicationState) =>
  state.AnalysisGenerationStore.fetched

export const selectCompletedAnalysisGenerations = (state: ApplicationState) =>
  state.AnalysisGenerationStore.completed
